module.exports = __webpack_public_path__ + "static/media/007.b6975b52.jpg";